<template>
  <DialogTemplate
    :show-controls="!mandatory"
    :close-click-outside="!mandatory"
    class="dialog"
  >
    <template #header>
      <div v-if="mediaObject || title" class="header-content">
        <img
          v-if="mediaObject"
          class="image"
          :src="mediaObject.urlCompressed || mediaObject.url"
          :alt="title"
          :width="mediaObject.width"
          :height="mediaObject.height"
        />
        <span v-if="title" class="title">{{ title }}</span>
      </div>
    </template>
    <div class="bullet-list-wrapper">
      <ul class="scrollable">
        <li v-for="(item, index) in bulletList" :key="`item-${index}`">
          <span class="icon-wrapper">
            <icon class="icon" name="quizQuestionSubmit" size="1.2rem" />
          </span>
          <strong>{{ `${item.label} : ` }}</strong>
          {{ `${item.value}` }}
        </li>
      </ul>
    </div>

    <template #footer>
      <div class="actions">
        <ButtonBase
          v-for="(action, index) in actions"
          :key="`action-${index}`"
          :variant="'tonal'"
          :disabled="playAction"
          stroke="n"
          :theme="action.highlighted ? 'secondary' : 'secondary-light'"
          rounded
          @click="() => handleClickAction(action)"
        >
          {{ action.label }}
        </ButtonBase>
      </div>
    </template>
  </DialogTemplate>
</template>
<script lang="ts" setup>
interface Props {
  mediaObject: MediaSchema;
  mandatory: boolean;
  title: string;
  bulletList: { label: string; value: string }[];
  actions: { label: string; highlighted: boolean; adamActionParameters: any }[];
}

defineProps({
  mediaObject: null,
  mandatory: { type: Boolean },
  title: null,
  bulletList: null,
  actions: null
});

const dialog = useDialogStore();

const playAction = ref<boolean>(false);

const route = useRoute();

const redirectToDeeplink = async (deeplink: string) => {
  const { path } = await useDeepLinkParser(deeplink);

  if (path) {
    const continuePath = route.fullPath;
    let separator = '?';
    if (path.includes('?')) {
      separator = '&';
    }
    navigateTo(`${path}${separator}continue=${continuePath}`, {
      external: path.includes('hhtp'),
    });
  }
};

const handleClickAction = async (action: {
  label: string;
  highlighted: boolean;
  adamActionParameters: any;
}) => {
  playAction.value = true;
  const { result } = await useApiFetch(URI.ProfileAction, {
    method: 'POST',
    body: {
      ...action.adamActionParameters,
    },
  });
  if (result && result.deeplink) {
    await redirectToDeeplink(result.deeplink);
  }
  dialog.close();
  playAction.value = false;
};
</script>
<style lang="scss" scoped>
.dialog {
  max-width: 50rem;
}

.header-content {
  display: flex;
  flex-direction: column;
  gap: var(--gap_n);
  align-items: center;
  justify-content: center;
}

.image {
  max-width: 14rem;
}

.title {
  @include font('m', 800, 'secondary');

  color: var(--color_secondary);
  text-align: center;
}
.bullet-list-wrapper {
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 40vh;
  max-height: 40dvh;
  padding: 2rem 0;
  gap: 1rem;
  @include font('n', 400, 'secondary');

  ul {
    display: flex;
    flex-direction: column;
    gap: 2rem;
    width: 100%;
    padding: 0 2rem 0 0;
    overflow-y: scroll;
    &::-webkit-scrollbar {
      width: 0.5rem;
    }
    &::-webkit-scrollbar-thumb,
    &::-webkit-scrollbar-track {
      border-radius: 0.25rem;
    }

    &::-webkit-scrollbar-thumb {
      background: var(--color_neutral_500);
    }

    &::-webkit-scrollbar-track {
      background: var(--color_neutral_100);
    }
  }
  .icon-wrapper {
    display: inline-block;
    width: 2rem;
    height: 2rem;
    margin-right: 0.5rem;
    border-radius: 50%;
    background-color: #4ae2c4;
    color: var(--color_neutral_25);
    font-size: 0.8rem;
    text-align: center;
    vertical-align: top;
    .icon {
      color: var(--color_neutral_25);
    }
  }
}

.hidden {
  opacity: 0.2;
}

.actions {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}
</style>
